import { render } from "./hero-course.vue?vue&type=template&id=11945e2a&ts=true"
import script from "./hero-course.vue?vue&type=script&lang=ts"
export * from "./hero-course.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__